const config = {
  auditTypeMap: [{ name: '待我审批', value: 1 }, { name: '我发起的', value: 2 }, { name: '抄送我的', value: 3 }, { name: '我处理的', value: 4 }],
  instStatusMap: [{ name: '全部', value: '' }, { name: '审批中', value: 1 }, { name: '已通过', value: 2 }, { name: '已拒绝', value: 3 }, { name: '已撤销', value: 4 }]
};
const formItems = [
  {
    label: '审批类型',
    model: 'auditType',
    type: 'select',
    options: config.auditTypeMap,
    span: 6
  },
  { label: '标题', model: 'title', type: 'input', span: 6 },
  { label: '发起人', model: 'applyUserName', type: 'input', span: 6 },
  { label: '发起时间', model: 'submitTime', type: 'daterange', span: 6 },
  { label: '完成时间', model: 'finishTime', type: 'daterange', span: 6 },
  {
    label: '流程状态',
    model: 'instStatus',
    type: 'select',
    options: config.instStatusMap,
    span: 6
  },
  {
    type: 'button',
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo', params: { auditType: 1, submitTime: ['', ''], finishTime: ['', ''] } }
    ],
    span: 12
  }
];
const getColumnsMap = (methods) => {
  return {
    remark: {
      title: '标题',
      key: 'remark',
      minWidth: 200,
      render: (h, params) => {
        const { title, id } = params.row;
        return h('a', {
          on: {
            click: () => {
              methods.goAudit(id);
            }
          }
        }, title);
      }
    },
    summary: {
      title: '摘要',
      key: 'summary',
      minWidth: 120,
      ellipsis: true,
      tooltip: true
    },
    applyUserName: {
      title: '发起人',
      key: 'applyUserName',
      minWidth: 80
    },
    submitTime: {
      title: '发起时间',
      key: 'submitTime',
      minWidth: 100
    },
    finishTime: {
      title: '完成时间',
      key: 'finishTime',
      minWidth: 100
    },
    instStatus: {
      title: '流程状态',
      key: 'instStatus',
      minWidth: 80,
      render: (h, params) => {
        const { instStatus, processStatus } = params.row;
        return h('span', processStatus);
      }
    }
  };
};
const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};
export { formItems, getColumns, config };
